let halllist = {
  hondo: {
    id: "hondo",
    name: "本渡斎場",
    nameen: "Tenseikaku Hondo",
    tel: "0969240983",
    zip: "〒863-0002",
    address: "熊本県天草市本渡町本戸馬場547",
    points: ["ご宿泊可能（浴室完備）", "1日1葬限定", "無料送迎"],
    parking: 80,
    capacity: 220,
    pickup: {
      sousaijou: {
        name: "葬祭場",
        img: "sousaijou.jpg",
        text: "故人がより偲ばれるセレモニーをご提案し心のこもったご葬儀を演出いたします。",
      },
      tsuya: {
        name: "通夜室",
        img: "tsuya.jpg",
        text: "故人との別れを惜しみ、思い出を心行くまで語り合いながら、ご冥福をお祈りいただけます。",
      },
      hikae: {
        name: "御親族控室",
        img: "hikae.jpg",
        text: "心穏やかに最後のお別れができますよう、宿泊もできる御親族控室をご用意いたしました。浴室も完備しております。",
      },
      parking: {
        name: "大駐車場",
        img: "gaikan.jpg",
        text: "参列者にご不便をかけることのないよう、大駐車場を完備いたしました。",
      },
    },
    vrimg: [
      ["vr01.jpg", "葬祭場"],
      ["vr02.jpg", "通夜室"],
      ["vr03.jpg", "館内ホール"],
      ["vr04.jpg", "入口"],
      ["vr05.jpg", "御親族控室"],
      ["vr06.jpg", "浴室"],
    ],
    img: [
      ["01.jpg", "一般葬祭壇"],
      ["02.jpg", "一般葬祭壇"],
      ["03.jpg", "一般葬祭壇"],
      ["04.jpg", "一般葬祭壇"],
      ["05.jpg", "家族葬祭壇"],
      ["06.jpg", "家族葬祭壇"],
    ],
    map: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4760.319774160521!2d130.1762526560347!3d32.47124431975162!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x353fefb025c139fb%3A0xeba7745cfe879cfc!2z5aSp6IGW6ZajIOacrOa4oeaWjuWgtA!5e0!3m2!1sja!2sjp!4v1664776798690!5m2!1sja!2sjp" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
  },
  itsuwa: {
    id: "itsuwa",
    name: "五和斎場",
    nameen: "Tenseikaku Itsuwa",
    tel: "0969330983",
    zip: "〒863-2421",
    address: "熊本県天草市五和町二江1510-1",
    points: ["ご宿泊可能（浴室完備）", "1日1葬限定", "無料送迎"],
    parking: 80,
    capacity: 220,
    pickup: {
      sousaijou: {
        name: "葬祭場",
        img: "sousaijou.jpg",
        text: "故人がより偲ばれるセレモニーをご提案し心のこもったご葬儀を演出いたします。",
      },
      tsuya: {
        name: "通夜室",
        img: "tsuya.jpg",
        text: "故人との別れを惜しみ、思い出を心行くまで語り合いながら、ご冥福をお祈りいただけます。",
      },
      hikae: {
        name: "御親族控室",
        img: "hikae.jpg",
        text: "心穏やかに最後のお別れができますよう、宿泊もできる御親族控室をご用意いたしました。浴室も完備しております。",
      },
      parking: {
        name: "大駐車場",
        img: "gaikan.jpg",
        text: "参列者にご不便をかけることのないよう、大駐車場を完備いたしました。",
      },
    },
    vrimg: [
      ["vr01.jpg", "葬祭場"],
      ["vr02.jpg", "通夜室"],
      ["vr03.jpg", "館内ホール"],
      ["vr04.jpg", "入口"],
      ["vr05.jpg", "御親族控室"],
      ["vr06.jpg", "浴室"],
    ],
    img: [
      ["01.jpg", "一般葬祭壇"],
      ["02.jpg", "一般葬祭壇"],
      ["03.jpg", "一般葬祭壇"],
      ["04.jpg", "一般葬祭壇"],
      ["05.jpg", "家族葬祭壇"],
      ["06.jpg", "家族葬祭壇"],
    ],
    map: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5495.4481138864585!2d130.1285900229909!3d32.54320021191254!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x353ffa900276ec7d%3A0xfd83dea9900aa79!2z6ZW35LqV5ZWG5LqL44ix5aSp6IGW6Zaj5LqU5ZKM!5e0!3m2!1sja!2sjp!4v1664776829789!5m2!1sja!2sjp" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
  },
  reihoku: {
    id: "reihoku",
    name: "苓北斎場",
    nameen: "Tenseikaku Reihoku",
    tel: "0969350983",
    zip: "〒863-2507",
    address: "熊本県天草郡苓北町富岡3558-4",
    points: ["ご宿泊可能（浴室完備）", "1日1葬限定", "無料送迎"],
    parking: 80,
    capacity: 220,
    pickup: {
      sousaijou: {
        name: "葬祭場",
        img: "sousaijou.jpg",
        text: "故人がより偲ばれるセレモニーをご提案し心のこもったご葬儀を演出いたします。",
      },
      tsuya: {
        name: "通夜室",
        img: "tsuya.jpg",
        text: "故人との別れを惜しみ、思い出を心行くまで語り合いながら、ご冥福をお祈りいただけます。",
      },
      hikae: {
        name: "御親族控室",
        img: "hikae.jpg",
        text: "心穏やかに最後のお別れができますよう、宿泊もできる御親族控室をご用意いたしました。浴室も完備しております。",
      },
      parking: {
        name: "大駐車場",
        img: "gaikan.jpg",
        text: "参列者にご不便をかけることのないよう、大駐車場を完備いたしました。",
      },
    },
    vrimg: [
      ["vr01.jpg", "葬祭場"],
      ["vr02.jpg", "通夜室"],
      ["vr03.jpg", "館内ホール"],
      ["vr04.jpg", "入口"],
      ["vr05.jpg", "御親族控室"],
      ["vr06.jpg", "浴室"],
    ],
    img: [
      ["01.jpg", "一般葬祭壇"],
      ["02.jpg", "一般葬祭壇"],
      ["03.jpg", "一般葬祭壇"],
      ["04.jpg", "一般葬祭壇"],
      ["05.jpg", "家族葬祭壇"],
      ["06.jpg", "家族葬祭壇"],
    ],
    map: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4760.319774160521!2d130.1762526560347!3d32.47124431975162!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x353fefb025c139fb%3A0xeba7745cfe879cfc!2z5aSp6IGW6ZajIOacrOa4oeaWjuWgtA!5e0!3m2!1sja!2sjp!4v1664776798690!5m2!1sja!2sjp" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
  },
};
export default halllist;
